{
  "error": "Fehler",
  "loading": "Wird geladen",
  "newUser": "Neuer Benutzer",
  "newUserGroup": "Neue Gruppe"
}
